export default __webpack_public_path__ + "static/media/howsell-4.bebf6e76.svg";